import CheckboxInput from './CheckboxInput';
import FieldGroup from '../../core/components/Forms/FieldGroup';

export default {
  Input: CheckboxInput,
  InputGroup: FieldGroup
};
